import React, { useCallback, useContext } from 'react'
import { AuthContext } from '../../../context/auth/auth-context'
import axios from 'axios'
import { type AlertColor, IconButton, Tooltip } from '@mui/material'
import LocalAtmIcon from '@mui/icons-material/LocalAtm'
import { formAlertErrorMessage, formAlertResponseMessageWithPrompt, isEmptyString } from '../../../utils/string-utils'

export interface RefreshFeesTableButtonProps {
  strategyId: string
  isApiConnected: boolean
  controlExecuteCommandUrl: string | null
  displayToastWithMessage: (message: string, severity: AlertColor) => void
}

const RefreshFeesTableButton: React.FC<RefreshFeesTableButtonProps> = (props) => {
  const { strategyId, isApiConnected, controlExecuteCommandUrl, displayToastWithMessage } = props
  const isDisabled = !isApiConnected || isEmptyString(controlExecuteCommandUrl)

  const { accessToken } = useContext(AuthContext)

  const refreshFeesTable = useCallback(() => {
    if (controlExecuteCommandUrl == null || controlExecuteCommandUrl.length === 0) {
      console.debug('[Strategy] Failed to refresh fees table (reason: invalid url)')
      displayToastWithMessage('The POST url is invalid - please check the related configuration again', 'warning')
      return
    }

    if (isEmptyString(strategyId)) {
      console.debug('[Strategy] No strategy data found - skipping action')
      displayToastWithMessage('No strategy data found - skipping action', 'warning')
      return
    }

    const message = {
      timestamp: new Date().toISOString(),
      strategyId,
      command: 'refreshFees',
    }

    axios
      .post(controlExecuteCommandUrl, message, { headers: { Authorization: `Bearer ${accessToken}` } })
      .then(response => {
        console.debug(response)
        displayToastWithMessage(formAlertResponseMessageWithPrompt(response), 'success')
      })
      .catch(error => {
        console.error(error)
        displayToastWithMessage(formAlertErrorMessage(error), 'error')
      })
  }, [strategyId, accessToken])

  return (
    <Tooltip title='Refresh fees table'>
      <span>
        <IconButton size='small' disabled={isDisabled} onClick={refreshFeesTable}>
          <LocalAtmIcon/>
        </IconButton>
      </span>
    </Tooltip>
  )
}

export default React.memo(RefreshFeesTableButton)
